import { render, staticRenderFns } from "./goodsCate.vue?vue&type=template&id=a663de06&"
import script from "./goodsCate.vue?vue&type=script&lang=js&"
export * from "./goodsCate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports